// Angular import
import { Component, Inject, OnInit, inject } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterModule } from '@angular/router';

// project import
import { Spinner } from './shared/spinner/spinner';
import { ToastModule } from 'primeng/toast';
import { ModulesService } from './services/modules/modules-service';
import { ThemeService } from './services/theme/theme-service';
import { NotificationService } from './services/notification/notification-service';
import { Subject, takeUntil } from 'rxjs';
import { SpinnerService } from './services/spinner/spinner-service';
import { Title } from '@angular/platform-browser';
import { TranslationService } from './services/configuration/translation-service';
@Component({
  selector: 'app-root',
  imports: [RouterModule, Spinner, ToastModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private themeService = inject(ThemeService);
  private notifService = inject(NotificationService);
  private spinner = inject(SpinnerService);
  private activatedRoute = inject(ActivatedRoute);
  private title = inject(Title);
  private translationService = inject(TranslationService);

  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.spinner.show();
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.spinner.hide();
      }

      let route = this.activatedRoute;

      while (route.firstChild) {
        route = route.firstChild;
      }

      const pageTitle = route.snapshot.data['title'];
      const translatedPageTitle = pageTitle ? this.translationService.translate(pageTitle) : null;
      this.title.setTitle(translatedPageTitle ? `QubeBiz+ ${translatedPageTitle}` : 'QubeBiz+');
    });

    this.themeService.loadMode();
    this.themeService.loadTheme();
  }

  ngOnDestroy() {
    this.notifService.stopConnection();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
